<template>

  <div class="YSPage">
    <div class="book-comfirming" v-if="layer">
		    <div class='f-modal' >
	            <div class='f-modal-head'>提示</div>
	            <div class='f-modal-body'>
	                <p>该活动已结束，期待您下次的参与！</p>
	            </div>
	        </div>
	  </div>
    <div class="head">
      <img src="../../assets/img/YS-head.jpg" alt="">
    </div>
    <div class="main">
      <img src="../../assets/img/YS-content.jpg" alt="">
      <div class="hotel-item">
        <!-- <div class="item" @click="routeToDetails('450540')"></div> -->
        <!-- <div class="item" @click="routeToDetails('209968')"></div> -->
        <div class="item" @click="routeToDetails('3145')"></div>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
      name: "YS88",
      data() {
        return {
          layer:false,
          coupon:''
        }
      },
      created() {
        this.coupon = this.$route.query.coupon
        this.dao.set('hotelCoupon',JSON.stringify(this.coupon));
        var End = new Date('2021-10-07 23:59:59').getTime()
        var Star = new Date().getTime()
        var flag = End - Star
        if(flag<0){
          this.layer = true
        }
      },
      mounted() {
      },
      methods:{
        // goPromote(){
        //   var userInfo=this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'';
        //   if(!userInfo.CustomerNO){
        //     this.$router.push({ path: '/login'});
        //   }else{
            
        //   }
        // },
        //进入详情页
        routeToDetails(ID){
          var obj={
            HotelID:ID,
            ProductType:4,
            From:1,
            CheckIn:'2021-10-01',
            CheckOut:'2021-10-02',
            RoomCount:1,
            AdultCount:2,
            ChildrenCount:0,
            MyCityRegionID:'',
          }
          this.dao.set('hotelDetailsParams',JSON.stringify(obj));
          if(this.coupon){
            this.$router.push('/hotelDetails?token=true');
          }else{
            this.$router.push('/hotelDetails');
          }
          
        },
      },

    }
</script>

<style scoped>

.main{
  position: relative;
}

.hotel-item{
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.item {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/YS88/YS88.vue